
import { getRequest, postRequest } from '../tools/ajax.js'

// 关联案件和顾问
const Link= params => postRequest('/api/pc/First/Link', params);
// 录入
const Add= params => postRequest('/api/pc/First/ReminderAdd',params);

// 查询所有日程安排
const Reminder= params => postRequest('/api/pc/First/Reminder',params);

// 编辑日程
const Edit= params => postRequest('/api/pc/First/Edit',params);

// 修改状态
const Upadte= params => postRequest('/api/pc/First/Update',params);

// 通知
const Notice= params => postRequest('/api/pc/First/AllNotice',params);

//标为已读
const NoticeRead = params => postRequest('/api/pc/First/NoticeRead',params);

//全部已读
const AllRead = params => postRequest('/api/pc/First/AllRead',params);

//未读条数
const NoticeUnread = params => postRequest('/api/pc/First/NoticeUnread',params);

//首页的通知
const FirstNotice = params => postRequest('/api/pc/First/Notice',params);

//首页的快捷录入
const EnterMenu = params => postRequest('/api/pc/First/EnterMenu',params);


//首页的搜索
const Search = params => postRequest('/api/pc/First/FirstSearch',params);
//冲突信息的详情
const ConflictWarn = params => postRequest('/api/pc/First/ConflictWarn',params);


export {
    Link,Add,Reminder,Edit,Upadte,Notice,NoticeRead,FirstNotice,NoticeUnread,EnterMenu,Search,ConflictWarn,AllRead
}